import React from 'react';
import { useSelector } from 'react-redux';
import { hobOrgSelector } from '../redux/selector';
import HobThankYouMmt from './mmt-components/HobThankYouMmt/HobThankYouMmt';
import HobThankYou from './gi-components/HobThankYou/HobThankYou';

const HobThankYouPage = () => {
  const orgId = useSelector(hobOrgSelector)

  return (
    <>
    {orgId === "MMT" ? <HobThankYouMmt /> : <HobThankYou />}
    </>
  )
}

export default HobThankYouPage;
